import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { BRAND } from "@/lib/site";
import SEO from "@/components/SEO";

export default function ThankYou() {
  React.useEffect(() => {
    // Fire GA4 generate_lead event on /thank-you page view.
    // Under Consent Mode v2 this is a no-op unless analytics_storage is granted.
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      try {
        window.gtag("event", "generate_lead", {
          method: "enquiry_form",
          page_path: "/thank-you",
          currency: "GBP",
          value: 50.0,
        });
      } catch { /* ignore */ }
    }
  }, []);

  return (
    <div data-testid="thankyou-page">
      <SEO title="Thank You" description="Your enquiry has been received." noindex={true} />
      <section className="border-b border-zinc-200">
        <div className="max-w-4xl mx-auto px-6 pt-32 pb-24 md:pt-40 md:pb-32">
          <div className="tech-label text-[#C2410C]">// Enquiry received</div>
          <div className="mt-6 inline-flex items-center gap-3 border border-zinc-900 px-4 py-2">
            <Check size={18} className="text-[#C2410C]" strokeWidth={2.5} />
            <span className="font-mono text-[11px] uppercase tracking-[0.2em]">Message delivered</span>
          </div>
          <h1 className="hero-heading text-5xl sm:text-6xl md:text-7xl mt-8">Thank you.</h1>
          <p className="mt-8 max-w-2xl text-lg text-zinc-700 leading-relaxed">
            We&apos;ve received your enquiry. A member of the team will be in touch within one working day, usually much sooner.
          </p>
          <p className="mt-6 max-w-2xl text-zinc-700 leading-relaxed">
            If your enquiry is urgent, feel free to call us on{" "}
            <a href={`tel:${BRAND.phoneDial}`} className="text-[#C2410C] underline">{BRAND.phone}</a>{" "}
            or email{" "}
            <a href={`mailto:${BRAND.email}`} className="text-[#C2410C] underline">{BRAND.email}</a>.
          </p>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link to="/" className="btn-primary" data-testid="thankyou-cta-home">
              Return to homepage <ArrowUpRight className="arrow" size={14} strokeWidth={2.5} />
            </Link>
            <Link to="/case-studies" className="btn-outline" data-testid="thankyou-cta-cases">
              Browse case studies <ArrowUpRight size={14} strokeWidth={2.5} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
